import { useEffect, useState } from "react";

// import ResumeData from "./ResumeData";
import { useDispatch, useSelector } from "react-redux";
import { deleteResume, downloadResume, getResume } from "./ManagementSlice";
import { Button } from "react-bootstrap";
// import { width } from "@fortawesome/free-solid-svg-icons/fa0";
import { toast } from "react-toastify";
import DeleteDialog from "../../../component/resuable/deleteDialog";
import StyledDataTable from "../../../component/resuable/StyledComponent";
import Header from "../../Navbar/Header";
import Sidebar from "../sidebar/Sidebar";

import Cookies from "js-cookie";
import refreshIcon from "../../../assests/images/refreshIcon.png";
import ManagementEditForm from "./ManagementEditForm";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";

export default function Management() {
  let role = Cookies.get("role");
  const location = useLocation();
  const dispatch = useDispatch();
  const isDirect = location.pathname.includes("/direct");
  const [cellclicked, setCellclicked] = useState("");
  const [search, setSearch] = useState("");
  const [arrivalDateFilter, setArrivalDateFilter] = useState("");
  const [companyNameSearch, setCompanyNameSearch] = useState("");

  const [selectedValue, setSelectedValue] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Default items per page
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [selectedData, setselectedData] = useState("");
  const [editData, setEditData] = useState("");
  const [activeTab, setActiveTab] = useState("pending");
  const [place, setPlace] = useState("");
  const { pendingCount, completedCount } = useSelector(
    (state) => state.management,
  );

  const handleClick = () => {
    setCellclicked("add");
    setEditData("");
  };
  const handleBack = () => {
    console.log("active tab value", activeTab);
    setActiveTab(activeTab);
    fetchData();
    setCellclicked("");
    setEditData("");
  };

  const handleDelete = async (id) => {
    const response = await dispatch(deleteResume(id));
    if (response.payload.status === 200) {
      fetchData();
      toast.success("User Data Deleted successfully");
    }
  };

  const handleEditClick = (data) => {
    setCellclicked("edit");
    setEditData(data);
  };

  const handleResumeDownload = async () => {
    const location = isDirect ? "Direct" : "chennai";
    dispatch(downloadResume(location));
  };

  const handleDeleteClick = (data) => {
    setselectedData(data.name);
    setDeleteId(data.id);
    setEditData(data);
    setShowDeleteDialog(true);
  };
  function capitalizeWords(str) {
    if (str !== undefined && str !== null) {
      return str
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    } else {
      return "";
    }
  }
  const columns = [
    {
      name: "S.No",

      selector: (row, index) => (currentPage - 1) * itemsPerPage + index + 1,
      width: "5%",
    },
    {
      name: "Name",
      selector: (row) => capitalizeWords(row.name),
      // width: "10%",
    },
    // {
    //   name: "Email",
    //   selector: (row) => row.email,
    // },
    {
      name: "Location",
      selector: (row) => row.location,
    },
    {
      name: "Company",
      selector: (row) => row.employeer_name,
    },
    {
      name: "Arrival Date",

      selector: (row) =>
        row.arrival_date ? dayjs(row.arrival_date).format("YYYY-MM-DD") : "",
      // selector: (row) => row.arrival_date,
    },

    {
      name: "Language",
      selector: (row) => row.language,
    },
    ...(role === "admin"
      ? [
          {
            name: "English Pdf",
            width: "12%",
            selector: (row) => (
              <a
                href={row.english_pdf}
                target="_blank"
                rel="noopener noreferrer"
              >
                {row.english_pdf !== null ? "Download" : "--"}
              </a>
            ),
          },
          {
            name: "Japanese Pdf",
            width: "15%",
            selector: (row) => (
              <a
                href={row.japanese_pdf}
                target="_blank"
                rel="noopener noreferrer"
              >
                {row.japanese_pdf !== null ? "Download" : "--"}
              </a>
            ),
          },
        ]
      : []),
    // {
    //   name: "English Resume",
    //   selector: (row) => (
    //     <a href={row.file_download} target="_blank" rel="noopener noreferrer">
    //       Download
    //     </a>
    //   ),
    // },
    // {
    //   name: "Japanese Resume",
    //   selector: (row) => (
    //     <a
    //       href={row.japanese_pdf}
    //       target="_blank"
    //       rel="noopener noreferrer"
    //     >
    //       {row.japanese_pdf !== null ? "Download" : "--"}
    //     </a>
    //   ),
    // },
    {
      name: "Action",
      cell: (row) => (
        <>
          <Button
            variant="danger"
            className="table-viewcustom-button"
            onClick={() => handleEditClick(row)}
          >
            <i className="fas fa-eye px-2"></i>
          </Button>
          {role === "admin" && (
            <Button
              variant="primary"
              className="table-custom-button"
              onClick={() => handleDeleteClick(row)}
              style={{ marginRight: "8px" }}
            >
              <i className="fas fa-trash px-2"></i>
            </Button>
          )}
        </>
      ),
      button: true,
    },
  ];

  const [rowData, setRowData] = useState([]);
  const candiateData = useSelector((state) => state.Resume.resumeData);

  const fetchData = async () => {
    const status = activeTab === "pending" ? "pending" : "completed";

    await dispatch(
      getResume({
        page: currentPage,
        perPage: itemsPerPage,
        search: search,
        management_status: status,
        employeer_name: companyNameSearch,
        status: selectedValue,
        arrival_date: arrivalDateFilter,
        data: isDirect ? "" : "all",
        location: isDirect ? "Direct" : "",
        place: !isDirect ? place : "",
      }),
    );
  };
  useEffect(() => {
    fetchData();
  }, [
    dispatch,
    currentPage,
    itemsPerPage,
    search,
    activeTab,
    companyNameSearch,
    selectedValue,
    arrivalDateFilter,
    place,
  ]);

  useEffect(() => {
    if (candiateData && Array.isArray(candiateData.candidates)) {
      const formattedData = candiateData.candidates.map((user) => ({
        ...user,
        name: user.name,
        email: user.email,
        phone: user.phone,
        skill: user.skill,
        // status: user.status,
        // current_salary: user.current_salary,
        // expected_salary: user.expected_salary,
        sex: user.sex,
        file_download: user.file_download,
        // location: user.location,
        // mode: user.mode,
        id: user.id,
        years_of_exp: user.years_of_exp,
        language: user.language,
        japanese_file_path: user.japanese_file_path,
        japanese_pdf: user.japanese_pdf,
        notice_period: user.notice_period,
        arrival_date: user.arrival_date,
        // contact_details: user.contact_details,
        emergency_contact: user.emergency_contact,
        coe: user.coe,
        employement_contract: user.employement_contract,
        air_ticket: user.air_ticket,
        passport_copy: user.passport_copy,
        resident_copy: user.resident_copy,
        visa: user.visa,
        remarks: user.remarks,
        option_file: user.option_file,
        employeer_name: user.employeer_name,

        //new fields
        admission_number: user.admission_number,
        ad_fees: user.ad_fees,
        // date_of_admission: user.date_of_admission,
        date_of_admission: user.date_of_admission
          ? new Date(user.date_of_admission)
          : "",
        dob: user.dob ? new Date(user.dob) : "",
        passport_no: user.passport_no,
        height: user.height,
        weight: user.weight,
        marital_status: user.marital_status,
        nationality: user.nationality,
        religion: user.religion,
        communication: user.communication,
        reference: user.reference,
        educational_qualification: user.educational_qualification,
        additional_qualification: user.additional_qualification,
        english_knowledge: user.english_knowledge,
        profile_pic: user.profile_pic,
        sign: user.sign,
        educationalCertificate: user.educationalCertificate,
        medicalReport: user.medicalReport,
        vaccinationCertificate: user.vaccinationCertificate,
      }));
      setRowData(formattedData);
    }
  }, [candiateData]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleRowsPerPageChange = (newPerPage) => {
    setItemsPerPage(newPerPage); // Update rows per page
    setCurrentPage(1); // Reset to the first page when changing rows per page
  };
  const handleSelectChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab); // Set active tab
  };

  useEffect(() => {
    console.log("active tab from resume", selectedValue);
  }, []);

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <Header />
          <div className="col-2 p-0">
            <Sidebar />
          </div>
          <div className="col-10 mt-2 px-3">
            <div className="card custom-card">
              <div className="row justify-content-center">
                {cellclicked === "" && (
                  <div>
                    <div className="col-md-12">
                      <div className="row py-3 d-flex justify-content-between">
                        {role !== "intermediate" && !isDirect && (
                          <div className="col-md-3">
                            <input
                              placeholder="Enter your company name"
                              className="form-control ms-2"
                              onChange={(e) =>
                                setCompanyNameSearch(e.target.value)
                              }
                            />
                          </div>
                        )}
                        {/* <div className="col-md-5 "> */}
                        {/* <div className="d-flex"> */}
                        {/* <input placeholder="search" className="form-control me-4" onChange={(e) => setSearch(e.target.value)} /> */}

                        {/* </div> */}

                        {/* </div> */}

                        {!isDirect && (
                          <div className={`col-md-4 text-end d-flex ms-2`}>
                            <select
                              className="form-select form-select mb-3"
                              aria-label="Large select example"
                              defaultValue=""
                              onChange={(e) => {
                                setPlace(e.target.value);
                                console.log(e.target.value);
                              }}
                              value={place}
                            >
                              <option value="" disabled hidden>
                                Select
                              </option>
                              <option value="chennai">Chennai</option>
                              <option value="kerala">Kerala</option>
                            </select>
                            <img
                              src={refreshIcon}
                              alt="select_refreshicon"
                              onClick={() => {
                                setPlace("");
                              }}
                              className="px-2 mt-2 cursor-pointer me-3"
                              height={20}
                              width={35}
                            />
                          </div>
                        )}

                        <div
                          className={`col-md-${!isDirect ? "5" : "7"} text-end`}
                        >
                          <div className="d-flex">
                            <input
                              placeholder="search"
                              className="form-control me-4"
                              onChange={(e) => setSearch(e.target.value)}
                            />
                            {role !== "intermediate" && !isDirect && (
                              <input
                                type="date"
                                placeholder="Select Date"
                                className="form-control me-4"
                                value={arrivalDateFilter || ""}
                                onChange={(e) =>
                                  setArrivalDateFilter(e.target.value)
                                }
                              />
                            )}
                            {/* <select value={selectedValue} onChange={handleSelectChange} className="form-select">
                                  <option value="" disabled selected>Select an option</option>
                                  <option value="Immediate Joiner">Immediate Joiner</option>
                                  <option value="Notice Period">Notice Period</option>
                            </select> */}
                            <img
                              src={refreshIcon}
                              alt="refreshicon"
                              onClick={() => {
                                setArrivalDateFilter(null);
                              }}
                              className="px-2 mt-2 cursor-pointer me-3"
                              height={20}
                              width={35}
                            />

                            {/* <button
                              className="btn defult-button defult-button-head mx-2"
                              type="buttons"
                              onClick={handleEditClick}
                            >
                              Edit
                            </button> */}
                          </div>

                          {/* <button className='btn defult-button defult-button-head mx-2' type="buttons" onClick={handleClick}>Add New</button> */}
                        </div>
                      </div>
                    </div>

                    {/* <div className="px-4" hidden>
                      <ul
                        className="nav nav-pills"
                        id="pills-tab"
                        role="tablist"
                      >
                        <li className="nav-item" role="presentation">
                          <button
                            className={`nav-link custom-link ${
                              activeTab === "pending" ? "active" : ""
                            }`}
                            id="pills-home-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#pills-home"
                            type="button"
                            role="tab"
                            aria-controls="pills-home"
                            aria-selected="true"
                            onClick={() => handleTabClick("pending")}
                          >
                            Pending Items ({pendingCount})
                          </button>
                        </li>
                        <li className="nav-item" role="presentation">
                          <button
                            className={`nav-link custom-link  ${
                              activeTab === "completed" ? "active" : ""
                            }`}
                            id="pills-profile-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#pills-profile"
                            type="button"
                            role="tab"
                            aria-controls="pills-profile"
                            aria-selected="false"
                            onClick={() => handleTabClick("completed")}
                          >
                            Completed Items ({completedCount})
                          </button>
                        </li>
                      </ul>
                    </div> */}
                    {isDirect && (
                      <div
                        className="col-md-12 px-4"
                        hidden={role === "kerala_hr"}
                      >
                        <div
                          className="d-flex justify-content-between
                        "
                        >
                          <ul
                            className="nav nav-pills"
                            id="pills-tab"
                            role="tablist"
                          >
                            <li className="nav-item" role="presentation">
                              <button
                                className={`nav-link custom-link ${activeTab === "pending" ? "active" : ""}`}
                                id="pills-home-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-home"
                                type="button"
                                role="tab"
                                aria-controls="pills-home"
                                aria-selected="true"
                                onClick={() => handleTabClick("pending")}
                              >
                                Pending Items ({pendingCount})
                              </button>
                            </li>
                            <li className="nav-item" role="presentation">
                              <button
                                className={`nav-link custom-link  ${activeTab === "completed" ? "active" : ""}`}
                                id="pills-profile-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-profile"
                                type="button"
                                role="tab"
                                aria-controls="pills-profile"
                                aria-selected="false"
                                onClick={() => handleTabClick("completed")}
                              >
                                Completed Items ({completedCount})
                              </button>
                            </li>
                          </ul>

                          <button
                            className="btn defult-button defult-button-head"
                            type="buttons"
                            style={{ width: 150 }}
                            onClick={handleResumeDownload}
                          >
                            Download
                          </button>
                        </div>
                      </div>
                    )}
                    {!isDirect && (
                      <div
                        className="col-md-12 px-4"
                        hidden={role === "kerala_hr"}
                      >
                        <div
                          className="d-flex justify-content-between
                        "
                        >
                          <ul
                            className="nav nav-pills"
                            id="pills-tab"
                            role="tablist"
                          >
                            <li className="nav-item" role="presentation">
                              <button
                                className={`nav-link custom-link ${activeTab === "pending" ? "active" : ""}`}
                                id="pills-home-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-home"
                                type="button"
                                role="tab"
                                aria-controls="pills-home"
                                aria-selected="true"
                                onClick={() => handleTabClick("pending")}
                              >
                                Pending Items ({pendingCount})
                              </button>
                            </li>
                            <li className="nav-item" role="presentation">
                              <button
                                className={`nav-link custom-link  ${activeTab === "completed" ? "active" : ""}`}
                                id="pills-profile-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-profile"
                                type="button"
                                role="tab"
                                aria-controls="pills-profile"
                                aria-selected="false"
                                onClick={() => handleTabClick("completed")}
                              >
                                Completed Items ({completedCount})
                              </button>
                            </li>
                          </ul>
                          <div>
                            <button
                              className="btn defult-button defult-button-head"
                              type="buttons"
                              style={{ width: 150 }}
                              onClick={handleResumeDownload}
                            >
                              Download
                            </button>
                            <button
                              style={{ width: 150, marginLeft: 10 }}
                              className="btn defult-button defult-button-head"
                              type="buttons"
                              onClick={handleClick}
                            >
                              Add New
                            </button>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="mt-2">
                      <StyledDataTable
                        columns={
                          isDirect
                            ? columns
                            : [
                                ...columns.slice(0, -1),
                                // {
                                //   name: "Japanese Resume",
                                //   selector: (row) => (
                                //     <a href={row.japanese_pdf} target="_blank" rel="noopener noreferrer">
                                //       {row.japanese_pdf !== null ? "Download" : "--"}
                                //     </a>
                                //   ),
                                // },
                                columns[columns.length - 1],
                              ]
                        }
                        data={rowData.length > 0 ? rowData : []}
                        highlightOnHover
                        pagination
                        paginationServer // Ensure server-side pagination is enabled
                        paginationPerPage={itemsPerPage}
                        paginationRowsPerPageOptions={[5, 10, 15]}
                        paginationTotalRows={candiateData.total}
                        paginationDefaultPage={currentPage}
                        onChangePage={handlePageChange} // This should trigger when the page changes
                        onChangeRowsPerPage={handleRowsPerPageChange}
                        responsive
                        persistTableHead={true}
                      />
                    </div>
                  </div>
                )}

                {/* {cellclicked === "add" && (
                                    <ResumeData handleBack={handleBack}  />
                                )} */}
                {cellclicked === "edit" && (
                  <ManagementEditForm
                    handleBack={handleBack}
                    editData={editData}
                  />
                )}
                {cellclicked === "add" && (
                  <ManagementEditForm handleBack={handleBack} />
                )}
                {showDeleteDialog && deleteId && (
                  <DeleteDialog
                    id={deleteId}
                    data={selectedData}
                    onDelete={handleDelete}
                    onClose={() => setShowDeleteDialog(false)}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
